import React, { Component } from "react";

export default class AndroidDevelopmentImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 831 729.99"
      >
        <path
          d="M724,703.57V631.23S752.17,682.52,724,703.57Z"
          transform="translate(0 0)"
          fill="#f1f1f1"
        />
        <path
          d="M725.72,703.56l-53.29-48.92S729.27,668.55,725.72,703.56Z"
          transform="translate(0 0)"
          fill="#f1f1f1"
        />
        <path
          d="M106.46,703.57V631.23S78.27,682.52,106.46,703.57Z"
          transform="translate(0 0)"
          fill="#f1f1f1"
        />
        <path
          d="M104.72,703.56,158,654.64S101.16,668.55,104.72,703.56Z"
          transform="translate(0 0)"
          fill="#f1f1f1"
        />
        <path
          d="M590.76,167.05h-3.87V61.24A61.24,61.24,0,0,0,525.65,0H301.48a61.24,61.24,0,0,0-61.24,61.24h0V641.72A61.23,61.23,0,0,0,301.48,703H525.65a61.23,61.23,0,0,0,61.24-61.23h0V242.36h3.87Z"
          transform="translate(0 0)"
          fill="#3f3d56"
        />
        <path
          d="M528.12,15.93H498.86a21.73,21.73,0,0,1-20.11,29.94H350.32a21.73,21.73,0,0,1-20.11-29.94H302.88a45.74,45.74,0,0,0-45.74,45.74V641.29A45.73,45.73,0,0,0,302.87,687H528.12a45.73,45.73,0,0,0,45.74-45.73h0V61.67a45.74,45.74,0,0,0-45.73-45.74Z"
          transform="translate(0 0)"
          fill="#fff"
        />
        <path
          d="M522.48,677.07h-214c-24.59,0-44.59-17.85-44.59-39.8V608.46c0-17.49,15.93-31.72,35.51-31.72H531.56c19.58,0,35.51,14.23,35.51,31.72v28.81C567.07,659.22,547.07,677.07,522.48,677.07Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          id="them3"
          d="M331,192.84H283.28a3.22,3.22,0,0,1-3.22-3.22V141.89a3.22,3.22,0,0,1,3.22-3.22H331a3.22,3.22,0,0,1,3.22,3.22v47.73A3.22,3.22,0,0,1,331,192.84Z"
          transform="translate(0 0)"
          fill={theme.highlight}
        />
        <path
          d="M403.25,192.84H355.52a3.23,3.23,0,0,1-3.23-3.22V141.89a3.23,3.23,0,0,1,3.23-3.22h47.73a3.22,3.22,0,0,1,3.22,3.22v47.73A3.22,3.22,0,0,1,403.25,192.84Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M475.48,192.84H427.75a3.22,3.22,0,0,1-3.22-3.22V141.89a3.22,3.22,0,0,1,3.22-3.22h47.73a3.23,3.23,0,0,1,3.23,3.22v47.73A3.23,3.23,0,0,1,475.48,192.84Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M547.72,192.84H500a3.22,3.22,0,0,1-3.22-3.22V141.89a3.22,3.22,0,0,1,3.22-3.22h47.73a3.22,3.22,0,0,1,3.22,3.22v47.73A3.22,3.22,0,0,1,547.72,192.84Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M330.84,281.21H283.11a3.23,3.23,0,0,1-3.22-3.23V230.25a3.22,3.22,0,0,1,3.22-3.22h47.73a3.22,3.22,0,0,1,3.22,3.22V278A3.23,3.23,0,0,1,330.84,281.21Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M403.07,281.21H355.35a3.24,3.24,0,0,1-3.23-3.23V230.25a3.23,3.23,0,0,1,3.23-3.22h47.72a3.22,3.22,0,0,1,3.23,3.22V278A3.23,3.23,0,0,1,403.07,281.21Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          id="theme2"
          d="M475.31,281.21H427.58a3.23,3.23,0,0,1-3.22-3.23V230.25a3.22,3.22,0,0,1,3.22-3.22h47.73a3.23,3.23,0,0,1,3.23,3.22V278A3.25,3.25,0,0,1,475.31,281.21Z"
          transform="translate(0 0)"
          fill={theme.highlight}
        />
        <path
          id="theme1"
          d="M547.55,281.21H499.82A3.23,3.23,0,0,1,496.6,278V230.25a3.22,3.22,0,0,1,3.22-3.22h47.73a3.22,3.22,0,0,1,3.22,3.22V278A3.23,3.23,0,0,1,547.55,281.21Z"
          transform="translate(0 0)"
          fill={theme.highlight}
        />
        <path
          d="M330.67,369.57H282.94a3.23,3.23,0,0,1-3.22-3.23V318.61a3.22,3.22,0,0,1,3.22-3.22h47.73a3.22,3.22,0,0,1,3.22,3.22v47.73A3.23,3.23,0,0,1,330.67,369.57Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M402.9,369.57H355.18a3.24,3.24,0,0,1-3.23-3.23V318.61a3.23,3.23,0,0,1,3.23-3.22H402.9a3.23,3.23,0,0,1,3.23,3.22v47.73A3.24,3.24,0,0,1,402.9,369.57Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M475.14,369.57H427.41a3.23,3.23,0,0,1-3.22-3.23V318.61a3.22,3.22,0,0,1,3.22-3.22h47.73a3.23,3.23,0,0,1,3.23,3.22v47.73A3.25,3.25,0,0,1,475.14,369.57Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M547.38,369.57H499.65a3.25,3.25,0,0,1-3.23-3.23V318.61a3.23,3.23,0,0,1,3.23-3.22h47.73a3.22,3.22,0,0,1,3.22,3.22v47.73A3.23,3.23,0,0,1,547.38,369.57Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M330.5,457.93H282.77a3.25,3.25,0,0,1-3.23-3.23V407a3.23,3.23,0,0,1,3.23-3.22H330.5a3.22,3.22,0,0,1,3.22,3.22V454.7A3.23,3.23,0,0,1,330.5,457.93Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M402.73,457.93H355a3.24,3.24,0,0,1-3.23-3.23V407a3.23,3.23,0,0,1,3.23-3.22h47.72A3.23,3.23,0,0,1,406,407V454.7A3.24,3.24,0,0,1,402.73,457.93Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M475,457.93H427.24A3.23,3.23,0,0,1,424,454.7V407a3.22,3.22,0,0,1,3.22-3.22H475a3.22,3.22,0,0,1,3.22,3.22V454.7A3.23,3.23,0,0,1,475,457.93Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M547.21,457.93H499.48a3.25,3.25,0,0,1-3.23-3.23V407a3.23,3.23,0,0,1,3.23-3.22h47.73a3.22,3.22,0,0,1,3.22,3.22V454.7A3.23,3.23,0,0,1,547.21,457.93Z"
          transform="translate(0 0)"
          fill="#e5e5e5"
        />
        <path
          d="M331,655.29H283.28a3.23,3.23,0,0,1-3.22-3.23V604.33a3.22,3.22,0,0,1,3.22-3.22H331a3.22,3.22,0,0,1,3.22,3.22v47.73A3.23,3.23,0,0,1,331,655.29Z"
          transform="translate(0 0)"
          fill="#fff"
        />
        <path
          d="M403.25,655.29H355.52a3.25,3.25,0,0,1-3.23-3.23V604.33a3.23,3.23,0,0,1,3.23-3.22h47.73a3.22,3.22,0,0,1,3.22,3.22v47.73A3.23,3.23,0,0,1,403.25,655.29Z"
          transform="translate(0 0)"
          fill="#fff"
        />
        <path
          d="M475.48,655.29H427.75a3.23,3.23,0,0,1-3.22-3.23V604.33a3.22,3.22,0,0,1,3.22-3.22h47.73a3.23,3.23,0,0,1,3.23,3.22v47.73A3.25,3.25,0,0,1,475.48,655.29Z"
          transform="translate(0 0)"
          fill="#fff"
        />
        <path
          d="M547.72,655.29H500a3.23,3.23,0,0,1-3.22-3.23V604.33a3.22,3.22,0,0,1,3.22-3.22h47.73a3.22,3.22,0,0,1,3.22,3.22v47.73A3.23,3.23,0,0,1,547.72,655.29Z"
          transform="translate(0 0)"
          fill="#fff"
        />
        <circle cx="392.11" cy="548.22" r="6.45" fill="#e5e5e5" />
        <circle cx="415.33" cy="548.22" r="6.45" fill="#e5e5e5" />
        <circle cx="438.55" cy="548.22" r="6.45" fill="#e5e5e5" />
        <path
          d="M830,704H1a1,1,0,0,1,0-2H830a1,1,0,0,1,0,2Z"
          transform="translate(0 0)"
          fill="#cbcbcb"
        />
        <path
          d="M326.36,507.1a13,13,0,0,0-1.76-19.93l12.6-44.63-23,7.3-8.44,41.27a13.11,13.11,0,0,0,20.56,16Z"
          transform="translate(0 0)"
          fill="#ffb7b7"
        />
        <path
          d="M332.89,479.75a5.72,5.72,0,0,1-1.24.1l-22-.44a5.83,5.83,0,0,1-5.72-6,4.49,4.49,0,0,1,.06-.73l22.35-151A18.51,18.51,0,0,1,344.56,306h0a18.42,18.42,0,0,1,18.37,18.46,17.91,17.91,0,0,1-.54,4.37L346.55,393l-9,81.66A5.82,5.82,0,0,1,332.89,479.75Z"
          transform="translate(0 0)"
          fill="#3f3d56"
        />
        <polygon
          points="342.11 718.11 354.37 718.11 360.2 670.82 342.1 670.82 342.11 718.11"
          fill="#ffb7b7"
        />
        <path
          d="M339,714.1h24.14a15.39,15.39,0,0,1,15.39,15.39v.5H339Z"
          transform="translate(0 0)"
          fill="#2f2e41"
        />
        <polygon
          points="394.38 714.12 406.56 715.49 417.63 669.15 399.65 667.13 394.38 714.12"
          fill="#ffb7b7"
        />
        <path
          d="M391.72,709.8l24,2.69h0a15.38,15.38,0,0,1,13.58,17l-.06.5L390,725.58Z"
          transform="translate(0 0)"
          fill="#2f2e41"
        />
        <path
          d="M330.6,455s-16.81,37.21-2,61.38l8.85,188.17h20.3l19.7-152,35,45-21.33,105L416,703.92l34.5-106.42S424,480.15,415.23,477.33l-5.75-26.83Z"
          transform="translate(0 0)"
          fill="#2f2e41"
        />
        <path
          d="M323.12,487.62S308,505,348,511s82-3,83-15S323.12,487.62,323.12,487.62Z"
          transform="translate(0 0)"
          fill="#cbcbcb"
        />
        <path
          d="M523.63,272.05a11.6,11.6,0,0,1-12,11.18,11.38,11.38,0,0,1-2-.25l-15.12,21.8L479,298.83l21.79-30.5a11.67,11.67,0,0,1,22.88,3.72Z"
          transform="translate(0 0)"
          fill="#ffb7b7"
        />
        <path
          d="M395.76,300.11l-21.37-9.67L347,292.39S314,331,327,368l-8,129c51,14,74.18-12.26,111-1L418.6,352.63Z"
          transform="translate(0 0)"
          fill="#3f3d56"
        />
        <path
          d="M381.48,309.5l14.28-9.39s19.85-3,27.78,4.69c0,0,26.93,2.26,33.43,9l7.16,1.61,23.79-30.8,14.56,7.91-21,57-62.88,3.13Z"
          transform="translate(0 0)"
          fill="#3f3d56"
        />
        <circle
          cx="370.22"
          cy="249.98"
          r="33.74"
          transform="translate(-74.54 208.21) rotate(-28.66)"
          fill="#ffb7b7"
        />
        <path
          d="M341,223.6c6-10.84,13.55-17.85,26-17.6s23.11-.24,28.68,10.83a18.13,18.13,0,0,0,2.15-9,10.31,10.31,0,0,1,4.54,10.35,7.49,7.49,0,0,0,3.7-6.17c4.14,1.38,5.22,7.21,3.12,11S403,229.1,399,231s-2.12,11.75-4.69,15.27c-1.8,2.46-2.62,5.47-3.83,8.26a.55.55,0,0,1-.24.26c-2.78,1.54-4.53,4.3-4,7.44a1.15,1.15,0,0,1,0,.71c-3.51,6.61-7.29,13.53-13.66,17.48a22.65,22.65,0,0,1-17,2.63c-6.5-1.56-12.12-5.87-16.18-11.18s-6.66-11.61-8.62-18c-1.74-5.67-3-11.74-1.62-17.51s6-11.11,12-11.55"
          transform="translate(0 0)"
          fill="#2f2e41"
        />
      </svg>
    );
  }
}
